import React from 'react'

const IncrementD = () => {
  return (
    <>
      <div className="increment">
        <div className="increment-heading">
            <h1>INCREMENT & DECREMENT</h1>
        </div>
        <div className="increment-main">
            <div className="increment-main-frame">
                <iframe src="https://Google.com"  frameborder="0"></iframe>
            </div>
        </div>
      </div>
    </>
  )
}

export default IncrementD
